import { render, staticRenderFns } from "./ThreeEventGreed.vue?vue&type=template&id=ab936148&scoped=true"
import script from "./ThreeEventGreed.vue?vue&type=script&lang=js"
export * from "./ThreeEventGreed.vue?vue&type=script&lang=js"
import style0 from "./ThreeEventGreed.vue?vue&type=style&index=0&id=ab936148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab936148",
  null
  
)

export default component.exports